<template>
  <div class="popup-wrapper">
    <div class="popup-body-wrapper">
      <div class="popup-body" :style="{'max-width': maxWidth +'px'}">
        <slot></slot>
      </div>
      <div class="backdrop" @click="$emit('close')"></div>
    </div>
  </div>
</template>

<script>
import Popup from "@/components/popup/Popup";

export default {
  name: "PopupController",

  components: {Popup},

  props: {
    maxWidth: {
      type: Number,
      required: true,
    }
  }

}
</script>

<style scoped lang="scss">
.popup-wrapper {
  position: relative;
  z-index: 1000;

  .popup-body-wrapper {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    .popup-body {
      position: relative;
      z-index: 1000;
      background-color: white;
      width: 100%;

      @media only screen and (max-width: 1024px) {
        max-width: calc(100vw - 30px) !important;
      }
    }
  }

  .backdrop {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 999;
  }
}
</style>